import PropTypes from 'prop-types'
import React, { useContext, useMemo } from 'react'

import ButtonScrollDown from 'components/ButtonScrollDown'
import { GOODS_TYPES } from 'constants/sales'
import AddAndGoToCart from 'containers/AddAndGoToCart'
import { FeaturesConsumer } from 'contexts/Features'
import { MenuMainContext } from 'contexts/MenuMain'
import { Button } from 'shared/Button'
import { Text } from 'shared/Typography'
import createNumberFormatter from 'utils/createPriceFormatter'
import { ResizeContext } from 'contexts/Resize'
import { useGoods } from 'modules/Home/components/Carousel/hooks'
import { LocalizationContext } from 'contexts/Localization'

import BacteriasEffect from './components/BacteriasEffect'
import {
  FirstBlockWrapperStyled,
  Container,
  TextContent,
  Prices,
  DiscountBadge,
  OldPrice,
  Price,
  Buttons,
} from './styles'

const BResultsFirst = props => {
  const { mobile } = useContext(ResizeContext)
  const { data, secondBlockRef } = props
  const { isSalesBanner, salesBannerHeight } = React.useContext(MenuMainContext)
  const { locale, dict } = React.useContext(LocalizationContext)
  const { goods, currency } = useGoods(locale)

  const formatter = useMemo(() => {
    if (!currency) return
    return createNumberFormatter({ locale, currency })
  }, [locale, currency])

  const price = goods?.microbiome.price
  const currentPrice = goods?.microbiome.currentPrice
  const discount = goods?.microbiome.discount

  return (
    <FirstBlockWrapperStyled
      isExtraTopIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
      className='pb-2 pb-md-4'
      beforeElement={
        <div className='position--full'>
          <FeaturesConsumer>
            {({ isBrowser, restrictUIX }) => (
              <BacteriasEffect
                isBrowser={isBrowser}
                restrictUIX={restrictUIX}
              />
            )}
          </FeaturesConsumer>
        </div>
      }
    >
      <Container>
        <TextContent>
          <Text
            weight='medium'
            size={['50/60', '50/60', '30/40']}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />

          <Text
            className='max-w--80p'
            size={['18/28', '18/28', '18/28']}
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </TextContent>

        <Prices>
          {price !== currentPrice && (
            <OldPrice>
              <Text
                as='h5'
                weight='medium'
                size={mobile ? '18/24' : '22/30'}
                decoration='line-through'
              >
                {formatter?.format(price)}
              </Text>

              {discount !== 0 && discount && (
                <DiscountBadge
                  size={['14/20', '14/20', '12/14']}
                  weight='medium'
                >
                  -{discount}%
                </DiscountBadge>
              )}
            </OldPrice>
          )}

          <Price
            size={mobile ? '25/30' : '50/60'}
            weight='medium'
          >
            {formatter?.format(currentPrice)}
          </Price>
        </Prices>

        <Buttons>
          <AddAndGoToCart
            goods={[
              {
                type: GOODS_TYPES.biome,
                isSubscription: false,
              },
            ]}
            ButtonComponent={Button}
            buttonTitleKey={'order_test'}
            forceMultipleAdd={true}
          >
            {dict.buttons.add_to_cart}
          </AddAndGoToCart>
        </Buttons>
      </Container>

      <div className='row'>
        <div className='col-12 pt-4'>
          <ButtonScrollDown
            title={data.go_to_site}
            refToScroll={secondBlockRef}
          />
        </div>
      </div>
    </FirstBlockWrapperStyled>
  )
}

BResultsFirst.propTypes = {
  data: PropTypes.object.isRequired,
  secondBlockRef: PropTypes.object.isRequired,
}

export default BResultsFirst
